import { CheckCircle2, CircleDashed } from "lucide-react";

interface DownstreamEffect {
  label: string;
  description?: string;
}

interface DownstreamEffectsListProps {
  title: string;
  description?: string;
  effects: DownstreamEffect[];
  emptyLabel?: string;
}

export function DownstreamEffectsList(props: Readonly<DownstreamEffectsListProps>) {
  const { title, description, effects, emptyLabel = "No downstream effects." } = props;

  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="space-y-1">
        <div className="text-sm font-semibold">{title}</div>
        {description ? (
          <div className="text-sm text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {effects.length === 0 ? (
        <div className="mt-3 flex items-center gap-2 text-sm text-muted-foreground">
          <CircleDashed className="h-4 w-4" />
          {emptyLabel}
        </div>
      ) : (
        <div className="mt-4 space-y-3">
          {effects.map((effect) => (
            <div key={effect.label} className="flex gap-3">
              <CheckCircle2 className="mt-0.5 h-4 w-4 text-emerald-600" />
              <div className="space-y-1">
                <div className="text-sm font-medium">{effect.label}</div>
                {effect.description ? (
                  <div className="text-sm text-muted-foreground">
                    {effect.description}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
